import { useStoreLogger } from '@/logger.ts'
import type {
  IAoeConsultant,
  IConsultantResponse
} from '@/types/ConsultantTypes.ts'
import { ConsultantGet } from '@/api/Consultant.ts'

export const ConsultantLocalStorageKey = 'AoeConsultant'

export function GetConsultantFromLocalStorage(
  beeNumberConsultant: number
): IAoeConsultant | null {
  const logger = useStoreLogger()
  logger.debug('GetConsultantFromLocalStorage', beeNumberConsultant)
  const key = ConsultantLocalStorageKey
  const json = localStorage.getItem(key)
  if (json) {
    logger.debug('Consultant found in local storage')
    const cust: IAoeConsultant = JSON.parse(json)
    if (cust.beeNumber === beeNumberConsultant) {
      return cust
    }
  }
  logger.debug('Consultant not found in local storage')
  return null
}

export async function GetConsultantFromLocalStorageOrApi(
  beeNumberConsultant: number
): Promise<IAoeConsultant | null> {
  const logger = useStoreLogger()
  logger.debug('GetConsultantFromLocalStorageOrApi', beeNumberConsultant)

  let cust = GetConsultantFromLocalStorage(beeNumberConsultant)
  if (cust) return cust

  const custResponse = await ConsultantGet(beeNumberConsultant)
  if (custResponse) {
    SaveConsultantToLocalStorage(custResponse)
    cust = GetConsultantFromLocalStorage(beeNumberConsultant)
  }
  return cust
}

export function SaveConsultantToLocalStorage(consultantResponse: IConsultantResponse) {
  const newValue = JSON.stringify(consultantResponse.item)
  const logger = useStoreLogger()
  logger.debug('SaveConsultantToLocalStorage', newValue)
  const key = ConsultantLocalStorageKey
  localStorage.setItem(key, newValue)
  window.dispatchEvent(
    new StorageEvent('storage', { key, newValue, storageArea: localStorage }),
  )
}
